import { useEffect } from 'react';
import { useRouter } from 'next/router';

import mixpanel from 'mixpanel-browser';

import useUser from '@/utils/hooks/swr/useUser';

export default function MixPanelInitializeUser() {
    const router = useRouter();
    const { user } = useUser();

    useEffect(() => {
        mixpanel.identify(String(user.admin_id));

        /**
         * set user properties
         */
        mixpanel.people.set({
            $email: user.email,
            $user_id: user.id,
            $first_name: user?.first_name ?? '',
            $last_name: user?.last_name ?? ''
        });
    }, []);

    useEffect(() => {
        function handleRouteChange(page: string, params?: { shallow: boolean }) {
            if (params?.shallow) {
                return;
            }
            mixpanel.track_pageview({ page });
        }

        handleRouteChange(router.pathname);

        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, []);

    return null;
}
